/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ViewportScroller} from '@angular/common';
import {ChangeDetectionStrategy, Component, HostListener, OnInit,} from '@angular/core';
import {FormControl} from '@angular/forms';
import {NavigationEnd} from '@angular/router';
import {NbWindowService} from '@nebular/theme';
import {DamEventService, FileService, LazyCatalog} from 'compob2b-libs';
import {Subscription} from 'rxjs';
import {filter, take, takeUntil, tap} from 'rxjs/operators';
import {translations} from '../../../../environments/translations.ru';
import {CrudConfig} from '../../../admin-shared/interfaces/crud.config';
import {FormConfigService} from '../../../admin-shared/services/form-config.service';
import {CatalogLazyComponent} from '../../pim/catalog/lazy-tree/catalog-lazy.component';
import {DamExternalUploadComponent} from '../dam-external-upload/dam-external-upload.component';
import {DAM_ITEM_FORM} from '../dam-forms.config';
import {DamShareComponent} from '../dam-share/dam-share.component';
import {DamCatalogService} from '../services/dam-catalog.service';

@Component({
  templateUrl: './dam-catalog-lazy.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DamCatalogLazyComponent extends CatalogLazyComponent implements OnInit {
  style: object = {};
  keyword = '';
  readonly formControl: FormControl;
  config: CrudConfig = {
    uri: '/dam/files',
    uriDelete: '/dam-menu',
    columns: DAM_ITEM_FORM,
    defaultSortColumn: 'header',
    defaultSortDirection: 'asc',
    title: translations.files
  };
  scrollPos: [number, number] = [0, 0];
  subscription: Subscription;
  readonly map = new Map<LazyCatalog, boolean>();
  canUpload = false;

  constructor(protected readonly formsConfig: FormConfigService,
              protected readonly windowService: NbWindowService,
              readonly catalogService: DamCatalogService,
              protected readonly fileService: FileService,
              protected scroller: ViewportScroller,
              protected readonly damEventService: DamEventService
  ) {
    super(formsConfig, windowService, catalogService, fileService);
  }

  ngOnInit() {
    this.catalogId = Number(this.route.snapshot.children[0].params.catalog_id) || 0;

    if (this.storeService.getCustomer()['roles'].some(obj => (obj.name === 'ROLE_ADMIN' || obj.name === 'ROLE_SUPER_ADMIN'))) {
      this.canUpload = true;
    }

    this.initCatalogTree();

    this.itemPage = this.router.url.indexOf('/item/') > -1;
    this.router.events.pipe(
      takeUntil(this.unsubscribe),
      filter(event => event instanceof NavigationEnd),
    ).subscribe((event: NavigationEnd) => {
      this.itemPage = event.url.indexOf('/item/') > -1;
      this.scroller.scrollToPosition(this.scrollPos);
    });

    this.route.queryParamMap.pipe(
      tap(params => {
        this.buildParams(params);
        this.cdr.detectChanges();
      }),
      takeUntil(this.unsubscribe),
    ).subscribe();

    super.setConfig(this.config);
    this.configure();
  }

  buildParams(params) {
    this.keyword = params.get('keyword');
    this.catalogId = Number(params.get('catalog_id') || 0);

    if (!this.catalogId) {
      this.data1.forEach(item => {
        const index = this.data1.indexOf(item);
        item.expanded = false;
        delete item.children;
        this.data1[index] = item;
      });
      this.cdr.detectChanges();
    }
    else {
      const clickItem = this.catalogService.getParent(this.data1, this.catalogId);
      if (clickItem === null) {
        this.initCatalogTree();
      }
      this.cdr.detectChanges();
    }
  }

  createExternalLink(id: number) {
    this.windowService.open(DamExternalUploadComponent, {
      context: {
        damCatalog: id,
      }
    });
  }

  navigateToId(id: number) {
    console.warn(id);
    if (!id) {
      this.router.navigate(['cabinet', 'dam']);
    }
    else {
      this.router.navigate(['cabinet', 'dam'], {queryParams: {catalog_id: this.catalogId}});
    }
  }

  @HostListener('keydown.enter')
  searchByKeyword() {
    if (this.keyword === '') {
      this.keyword = null;
    }

    this.onNavigate({keyword: this.keyword, page: null});
  }

  shareDamItems(damCatalogId: number): void {
    this.windowService.open(DamShareComponent, {
      context: {
        damItems: [],
        damCatalog: damCatalogId,
        shareType: 1
      }
    });
  }

  downloadDamCatalog(damCatalogId: number): void {
    this.fileService.downloadUrl('/dam-download/dam-catalog/' + damCatalogId)
      .pipe(take(1))
      .subscribe(response => {
        FileService.saveAs(response, 'download.zip');
      });
  }

}
